import React from "react";

const WelcomeSection = () => {
  return (
    <section className="layout-pt-md layout-pb-lg !pt-8 md:pt-16 pb-24">
      <div className="container !mx-auto !w-full !px-0 md:!px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 bg-orange-50 p-6 md:p-8 rounded-lg shadow-md !mx-0 md:!mx-4 lg:!mx-6">
          <div className="w-full">
            <h2 className="text-xl md:text-3xl font-bold text-[#ff9245] text-center lg:text-left">
              Tools: Your Partner in Every Step of Your NEET Journey
            </h2>
            <div className="mt-4 flex flex-col lg:flex-row items-start lg:items-center gap-4">
              <p className="text-base md:text-lg text-gray-700 leading-relaxed lg:w-1/2">
                Navigating the NEET journey can feel overwhelming, but our Tools
                are here to make it easier. Imagine having the College Predictor
                to guide you toward the best-fit colleges for your rank and
                preferences. With the Rank Predictor, you can estimate your
                standing and plan accordingly. Whether it’s comparing colleges
                with the College Compare tool, creating a detailed college list
                using the College Search, or checking out the College Ranking,
                we’ve got you covered. Need clarity on fees? The Fee Seat Matrix
                breaks down costs for MCC and state colleges, while the Cut-Off
                Allotment tool helps you plan effectively by analyzing past
                trends. Our AISearch provides personalized insights, the
                Admission Committee Support ensures you’re prepared for
                counselling, and News Alerts keep you updated on everything
                NEET. And if you want to boost your score, the NEET Score
                Booster is the perfect companion.
              </p>
              <img
                src="assets/images/services-img/Tools.webp"
                alt="Tools"
                className="rounded-lg lg:w-1/2"
              />
            </div>
          </div>
        </div>

        {/* Our Mission Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center mt-16 gap-12 bg-white p-6 md:p-8 rounded-lg shadow-md !mx-0 md:!mx-4 lg:!mx-6">
          <div className="w-full">
            <h2 className="text-xl md:text-3xl font-bold text-[#ff9245] text-center lg:text-left">
              Analysis: Your Data-Driven Decision-Making Tool
            </h2>
            <div className="mt-4 flex flex-col lg:flex-row items-start lg:items-center gap-4">
              <img
                src="assets/images/services-img/Analysis.webp"
                alt="Analysis"
                className="rounded-lg lg:w-1/2"
              />
              <p className="text-base md:text-lg text-gray-700 leading-relaxed lg:w-1/2">
                When it comes to NEET, understanding the numbers can make all
                the difference. Our Analysis section offers tools like Exam
                Paper Analysis, giving you insights into past patterns, and
                Five-Year Competition Trends to help you see where you stand.
                The Merit List helps you track the competition, while the Seat
                Matrix provides a clear view of seat availability. To top it
                off, our Cut-Off Analysis ensures you’re making decisions backed
                by real data—no guesswork, just smart planning.
              </p>
            </div>
          </div>
        </div>

        {/* Our Vision Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center mt-16 gap-12 bg-orange-50 p-6 md:p-8 rounded-lg shadow-md !mx-0 md:!mx-4 lg:!mx-6">
          <div className="w-full">
            <h2 className="text-xl md:text-3xl font-bold text-[#ff9245] text-center lg:text-left">
              Resources: Everything You Need at Your Fingertips
            </h2>
            <div className="mt-4 flex flex-col lg:flex-row items-start lg:items-center gap-4">
              <p className="text-base md:text-lg text-gray-700 leading-relaxed lg:w-1/2">
                We believe in equipping you with the right resources to succeed.
                Join our Free Webinars or participate in Exclusive Webinar
                Workshops for insider tips and tricks. For those tackling state
                counselling, the Domicile State Counselling eBook is a
                must-have. Our Medical Guide eBook and Physical Book give you a
                deep dive into the medical world, while Counselling Videos
                provide step-by-step guidance. To keep everything organized, the
                Documents Checklist ensures you don’t miss a thing.
              </p>
              <img
                src="assets/images/services-img/Resources.webp"
                alt="Resources"
                className="rounded-lg lg:w-1/2"
              />
            </div>
          </div>
        </div>

        {/* Pre-Exam Mentorship Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center mt-16 gap-12 bg-white p-6 md:p-8 rounded-lg shadow-md !mx-0 md:!mx-4 lg:!mx-6">
          <div className="w-full">
            <h2 className="text-2xl md:text-3xl font-bold text-[#ff9245] text-center lg:text-left">
              Pre-Exam Mentorship: Personalized Guidance for Success
            </h2>
            <div className="mt-4 flex flex-col lg:flex-row items-start lg:items-center gap-4">
              <img
                src="assets/images/services-img/Pre.webp"
                alt="Pre exam"
                className="rounded-lg lg:w-1/2"
              />
              <p className="text-base md:text-lg text-gray-700 leading-relaxed lg:w-1/2">
                Preparing for NEET isn’t just about studying—it’s about
                strategy, mindset, and focus. That’s why we offer Pre-Exam
                Mentorship. Your Academic Mentor will help you tackle weak spots
                and solidify your strengths, while your Success Coach will keep
                you motivated, confident, and on track to ace the exam.
              </p>
            </div>
          </div>
        </div>

        {/* Post-Exam Mentorship Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center mt-16 gap-12 bg-orange-50 p-6 md:p-8 rounded-lg shadow-md !mx-0 md:!mx-4 lg:!mx-6">
          <div className="w-full">
            <h2 className="text-xl md:text-3xl font-bold text-[#ff9245] text-center lg:text-left">
              Post-Exam Mentorship: Support When You Need It Most
            </h2>
            <div className="mt-4 flex flex-col lg:flex-row items-start lg:items-center gap-4">
              <p className="text-base md:text-lg text-gray-700 leading-relaxed lg:w-1/2">
                The real challenge begins after the exam. With our Post-Exam
                Mentorship, you’ll have a team by your side for every step. Our
                Senior Mentors and Junior Mentors bring expertise and experience
                to guide you through counselling. From Documentation and
                Application Filling to the all-important Choice Filling, we
                ensure every detail is handled with care so you can focus on
                your next big step.
              </p>
              <img
                src="assets/images/services-img/Post.webp"
                alt="Post exam"
                className="rounded-lg lg:w-1/2"
              />
            </div>
          </div>
        </div>

        {/* Customer Support Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center mt-16 gap-12 bg-white p-6 md:p-8 rounded-lg shadow-md !mx-0 md:!mx-4 lg:!mx-6">
          <div className="w-full">
            <h2 className="text-xl md:text-3xl font-bold text-[#ff9245] text-center lg:text-left">
              Customer Support: We’re Here for You, Always
            </h2>
            <div className="mt-2 md:mt-4 flex flex-col lg:flex-row items-start lg:items-center gap-4">
              <img
                src="assets/images/services-img/Customer.webp"
                alt="Customer Support"
                className="rounded-lg lg:w-1/2"
              />
              <p className="text-base md:text-lg text-gray-700 leading-relaxed lg:w-1/2">
                Got questions? Need guidance? Our Customer Support team is just
                a message away. Whether you prefer chatting over a call, meeting
                on Google Meet, or quick solutions through chat, we’ve got you
                covered. We’re here to provide personalized counselling and
                support whenever you need it because your success is our
                priority. Your NEET journey is unique, and we’re committed to
                helping you make it a success. With tools, mentorship, and
                resources designed just for you, NEET Support is your trusted
                partner every step of the way.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
